const state = {
    typeOfCommissions: [],
};

export default state;